import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import AnimateHeight from 'react-animate-height';

class Drawer extends PureComponent {
  state = {
    height: this.props.default === 'closed' ? 0 : 'auto',
  };

  setHeight = (height) => this.setState({ height });

  componentDidUpdate = (prevProps) => {
    const { toggle } = this.props;
    const { height } = this.state;
    const isToggled = prevProps.toggle !== toggle;

    if (isToggled && height) {
      this.setHeight(0);
    } else if (isToggled && !height) {
      this.setHeight('auto');
    }
  };

  render = () => {
    const { children, duration, handleAnimationEnd, delay } = this.props;
    const { height } = this.state;

    return (
      <AnimateHeight
        duration={duration}
        delay={delay}
        height={height}
        onAnimationEnd={handleAnimationEnd}
        style={{
          width: '100%',
        }}
      >
        {children}
      </AnimateHeight>
    );
  };
}

Drawer.propTypes = {
  children: PropTypes.node,
  duration: PropTypes.number,
  delay: PropTypes.number,
  toggle: PropTypes.bool,
  default: PropTypes.string,
  handleAnimationEnd: PropTypes.func,
};

Drawer.defaultProps = {
  duration: 300,
};

export default Drawer;
